export default "__VITE_ASSET__af65c686__"